import React, { useState } from 'react';

import { describeDonutSlice } from './chartUtils';

const PieChart = ({ slices, total, emptyMessage = 'No data' }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  if (!slices.length) {
    return <p className="analytics-empty">{emptyMessage}</p>;
  }

  const size = 160;
  const cx = size / 2;
  const cy = size / 2;
  const outerR = size / 2 - 4;
  const innerR = outerR * 0.55;

  let angle = 0;
  const arcs = slices.map((slice, index) => {
    const sweep = (slice.percent / 100) * 360;
    const startAngle = angle;
    const endAngle = angle + sweep;
    angle = endAngle;

    return {
      ...slice,
      index,
      path:
        sweep >= 359.99
          ? null
          : describeDonutSlice(cx, cy, outerR, innerR, startAngle, endAngle),
    };
  });

  const activeSlice = activeIndex != null ? slices[activeIndex] : null;

  return (
    <div className="pie-chart-wrap">
      <div className="pie-chart-visual">
        <svg
          viewBox={`0 0 ${size} ${size}`}
          className="pie-chart-svg"
          role="img"
          aria-label="Distribution chart"
        >
          {arcs.map((arc) =>
            arc.path ? (
              <path
                key={arc.label}
                d={arc.path}
                fill={arc.color}
                className={`pie-slice ${
                  activeIndex === arc.index ? 'pie-slice-active' : ''
                }`}
                onMouseEnter={() => setActiveIndex(arc.index)}
                onMouseLeave={() => setActiveIndex(null)}
              />
            ) : (
              <circle
                key={arc.label}
                cx={cx}
                cy={cy}
                r={outerR}
                fill={arc.color}
                className="pie-slice"
              />
            )
          )}
          <circle cx={cx} cy={cy} r={innerR} className="pie-chart-center" />
          <text
            x={cx}
            y={cy - 6}
            textAnchor="middle"
            className="pie-center-value"
          >
            {activeSlice ? activeSlice.value : total}
          </text>
          <text
            x={cx}
            y={cy + 14}
            textAnchor="middle"
            className="pie-center-label"
          >
            {activeSlice
              ? `${Math.round(activeSlice.percent)}%`
              : 'tracks'}
          </text>
        </svg>
      </div>

      <ul className="pie-legend">
        {slices.map((slice, index) => (
          <li
            key={slice.label}
            className={`pie-legend-item ${
              activeIndex === index ? 'pie-legend-item-active' : ''
            }`}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <span
              className="pie-legend-swatch"
              style={{ backgroundColor: slice.color }}
            />
            <span className="pie-legend-label" title={slice.label}>
              {slice.label}
            </span>
            <span className="pie-legend-meta">
              {slice.value}{' '}
              <span className="pie-legend-pct">
                ({Math.round(slice.percent)}%)
              </span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PieChart;
